module.exports = __webpack_public_path__ + "img/agency_thumbnail-400x300.1be63251.jpg";